import axiosInstance from '../../utils/axios';
import axios from 'axios';
import { VirtualWalletDTO } from './interface';

export const getVirtualWallet = async (): Promise<VirtualWalletDTO> => {
  try {
    const response = await axiosInstance.get<{ status: string; data: VirtualWalletDTO }>(
      'v2/virtual-wallet',
    );
    return response.data.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data?.error || 'UNKNOWN_ERROR';
    }
    throw error;
  }
};
